import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-top: ${({ theme }) => theme.spacing.md};
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;
`;

export const HeaderCell = styled.th`
  padding: ${({ theme }) => theme.spacing.xs};
  text-align: center;
  border-bottom: 2px solid ${({ theme }) => theme.colors.border.medium};
  color: ${({ theme }) => theme.colors.text.secondary};
  white-space: nowrap;
  font-size: 16px;
  line-height: 1.0;
  background-color: ${({ theme }) => theme.colors.backgroundTableHeader};
`;

export const Day = styled.div`
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
`;

export const DayOfWeek = styled.div`
  font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
`;

export const Cell = styled.td<{ $completed?: boolean; $partial?: boolean; $hydration?: boolean }>`
  padding: ${({ theme }) => theme.spacing.sm};
  text-align: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  white-space: nowrap;
  font-size: 16px;
  line-height: 1.0;

  ${({ $completed, theme }) => $completed && `
    background-color: ${theme.colors.backgroundTableGood};
    color: ${theme.colors.primary};
    font-weight: ${theme.typography.fontWeight.bold};
  `}

  ${({ $partial, theme }) => $partial && `
    background-color: white;
    color: ${theme.colors.text.primary};
    font-weight: ${theme.typography.fontWeight.semibold};
  `}

  ${({ $hydration, theme }) => $hydration && `
    background-color: white;
    color: ${theme.colors.text.primary};
    font-weight: ${theme.typography.fontWeight.bold};
  `}
`;

export const LabelCell = styled.td`
  padding: ${({ theme }) => theme.spacing.sm};
  text-align: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 16px;
  background-color: ${({ theme }) => theme.colors.backgroundTableHeader};
  min-width: 48px;
`;

export const Unit = styled.span`
  font-size: 15px;
  color: #666;
  font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
`;
